import type { FaireProductEntity } from "../../entity_types/product";

export const p_8gxve2ml10: FaireProductEntity = {
  token: "p_8gxve2ml10",
  type: "product",
  name: "Hey, Sugar All Natural Body Scrub - Coconut Vanilla",
  brandName: "NCLA Beauty",
  imageUrl:
    "https://cdn.faire.com/fastly/7e7257ca570e83fe465284fa569c288b34e56549dbd552a6955f7eb5c28913b3.jpeg",
  priceDollars: 18,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/9039469e50ce82350237f8bfdf9aff1bb84e83bb68222c83ecd9b5c64447086d.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
